"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APOLLO_OVERWRITE = 'APOLLO_OVERWRITE';
exports.APOLLO_RESET = 'APOLLO_RESET';
exports.APOLLO_WRITE = 'APOLLO_WRITE';
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-cache-redux/lib/constants.js
// module id = 97
// module chunks = 104158497352714 114276838955818 230539012308250